<template>
  <div>
    <van-field readonly clickable right-icon="arrow-down" placeholder="请选择" :value="value" @click="popup = true" />
    <van-popup ref="popup" v-model="popup" round position="bottom" :close-on-click-overlay="false">
      <van-picker show-toolbar :columns="list" @cancel="onCancel" @confirm="onConfirm">
        <template v-slot:option="{ label, value }">
          <div class="truncate">{{ label }}</div>
        </template>
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'SingleSelect',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      popup: false,
      value: ''
    }
  },
  methods: {
    onCancel() {
      this.popup = false
    },
    onConfirm(val) {
      this.value = val.label
      this.$emit('confirm', val)
      this.onCancel()
    },
    changeValue(value) {
      let find = this.list.find(i => i.value === value)
      this.value = find.label
    }
  }
}
</script>
